module.exports = __webpack_public_path__ + "static/fullWeb-ad06651939fddda3218fb294921e7cd9.svg";